"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultRenderLink = exports.AvatarLink = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _link = require("../link");

var _avatarConstants = require("./avatarConstants");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var AvatarLink = ( /*#__PURE__*/0, _styledBase.default)(_link.Link, {
  target: "e1y3lumh0"
})(process.env.NODE_ENV === "production" ? {
  name: "10i63lj",
  styles: ":hover{text-decoration:underline;}"
} : {
  name: "10i63lj",
  styles: ":hover{text-decoration:underline;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
exports.AvatarLink = AvatarLink;
AvatarLink.defaultProps = _objectSpread(_objectSpread({}, _link.Link.defaultProps), {}, {
  textDecoration: 'none'
});
AvatarLink.propTypes = _objectSpread({}, _link.Link.propTypes);

var onClick = function onClick(e) {
  // Prevent the event from bubbling, which stops issues
  // such as onRowClick being fired when clicking the link
  // in tables.
  e.stopPropagation();
};

var defaultRenderLink = function defaultRenderLink(_ref) {
  var username = _ref.username,
      accessibleUsername = _ref.accessibleUsername,
      newTabHiddenText = _ref.newTabHiddenText,
      lineHeight = _ref.lineHeight,
      fontSize = _ref.fontSize,
      colorScheme = _ref.colorScheme,
      id = _ref.id;
  var cssValues = {
    color: colorScheme === _interfaces.AvatarColorScheme.Inverted ? _avatarConstants.INVERTED_COLOR_SCHEME.linkColor : _avatarConstants.DEFAULT_COLOR_SCHEME.linkColor,
    fontSize: fontSize,
    lineHeight: lineHeight,
    textDecoration: colorScheme === _interfaces.AvatarColorScheme.Inverted ? 'underline' : undefined
  };
  return (0, _core.jsx)(AvatarLink, (0, _extends2.default)({}, cssValues, {
    href: "".concat(_avatarConstants.PHONE_TOOL_URL).concat(username),
    onClick: onClick,
    target: "_blank",
    "aria-describedby": id
  }), accessibleUsername, (0, _core.jsx)("span", {
    hidden: true,
    id: id
  }, newTabHiddenText));
};

exports.defaultRenderLink = defaultRenderLink;